module.exports = __webpack_public_path__ + "ab7508c696ebccbee3790c3b1dbe8660.pdf";